import { render } from "./ImageStoreSelectView.vue?vue&type=template&id=d8c916b8&scoped=true"
import script from "./ImageStoreSelectView.vue?vue&type=script&lang=js"
export * from "./ImageStoreSelectView.vue?vue&type=script&lang=js"

import "./ImageStoreSelectView.vue?vue&type=style&index=0&id=d8c916b8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c916b8"]])

export default __exports__